// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1ku0M","content":"styles_content__FYsV5","flexButton":"styles_flexButton__23Ik6","formikErrors":"styles_formikErrors__2Hl3r"};